import { createFileRoute } from '@tanstack/react-router'

import { OAuthLinkOldAccountRoute } from '@/pages/auth/route-entries/oauth-link-old-account'

export const Route = createFileRoute('/_auth/login/oauth/link-old-account')({
  component: OAuthLinkOldAccountRoute,
})
